import { connect } from 'react-redux';
import { selectIsDesktop } from 'selectors/ui';
import ColumnLayout from './ColumnLayout';
import { setColumnFocus } from './ColumnLayout.saga';
import { selectColumnFocus } from './ColumnLayout.selectors';

const mapStateToProps = state => ({
  isDesktop: selectIsDesktop(state),
  focus: selectColumnFocus(state),
});

const mapDispatchToProps = {
  setColumnFocus,
};

export default connect(mapStateToProps, mapDispatchToProps)(ColumnLayout);
